import {
    isAfter,
    isBefore,
    startOfDay,
    addDays,
    format,
    setHours,
    setMinutes,
    getHours,
    getMinutes,
} from 'date-fns';

export const areRangesOverlapping = (
    initialStartDate,
    initialEndDate,
    comparedStartDate,
    comparedEndDate,
) => {
    if (
        isAfter(new Date(initialStartDate), new Date(initialEndDate)) ||
        isAfter(new Date(comparedStartDate), new Date(comparedEndDate))
    ) {
        throw new Error(
            'The start of the range cannot be after the end of the range',
        );
    }

    return (
        isBefore(new Date(initialStartDate), new Date(comparedEndDate)) &&
        isBefore(new Date(comparedStartDate), new Date(initialEndDate))
    );
};

export const eachDay = (startDate, endDate, formatStr = null) => {
    let day = startOfDay(new Date(startDate));
    const result = [];

    if (isAfter(day, new Date(endDate))) {
        throw new Error('The first date cannot be after the second date');
    }

    while (!isAfter(day, new Date(endDate))) {
        result.push(formatStr ? format(day, formatStr) : day);
        day = addDays(day, 1);
    }

    return result;
};

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

// Parse a date value as LOCAL time. new Date('yyyy-MM-dd') interprets
// date-only strings as UTC midnight, which is the previous local day in
// negative-offset timezones; everything else parses local already.
export const parseLocalDate = (value) => {
    if (typeof value === 'string' && DATE_ONLY_PATTERN.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day);
    }
    return new Date(value);
};

export const convertMinutesToDateTime = (minutes, date = new Date()) => {
    const hour = Math.trunc(minutes / 60);
    const minute = minutes % 60;
    return setMinutes(setHours(parseLocalDate(date), hour), minute);
};

export const convertDateTimeToMinutes = (dateTime) => {
    const d = parseLocalDate(dateTime);
    return getHours(d) * 60 + getMinutes(d);
};
